
import { useQuery, useMutation } from "@tanstack/react-query";
import * as request from "./ApiClient";
import * as toast from "./ApiToast";
import { FetchDataParams, PostDataParams } from "types/common";

export const useFetchData = <TData = any>({
  key,
  baseURL = null,
  url,
  data = {},
  headers = {},
  options = {},
  post = false,
  accessToken = true,
}: FetchDataParams<TData>) =>
  useQuery<TData>({
    queryKey: [key],
    queryFn: async (): Promise<TData> => {
      const requestConfig = { baseURL, url, data, headers, accessToken };
      const response = !post
        ? await request.get(requestConfig)
        : await request.post(requestConfig);
      return response.data as TData;
    },
    ...options,
  });

export const usePostData = <TData = any, TVariables = any, TError = any>({
  baseURL = null,
  url,
  headers = {},
  options = {},
  withToastSuccess = true,
  withToastError = true,
  accessToken = true,
}: PostDataParams<TData, TVariables, TError>) =>
  useMutation<TData, TError, TVariables>({
    mutationFn: (data: TVariables) =>
      request.post({ baseURL, url, data, headers, accessToken }) as Promise<TData>,
    ...(withToastSuccess && { onSuccess: toast.success }),
    ...(withToastError && { onError: toast.error }),
    ...options,
  });

export const useDeleteData = <TData = any, TVariables = any, TError = any>({
  baseURL = null,
  url,
  headers = {},
  options = {},
  withToastSuccess = true,
  withToastError = true,
  accessToken = true,
}: PostDataParams<TData, TVariables, TError>) =>
  useMutation<TData, TError, TVariables>({
    mutationFn: (data: TVariables) =>
      request.deleteRequest({ baseURL, url, data, headers, accessToken }) as Promise<TData>,
    ...(withToastSuccess && { onSuccess: toast.success }),
    ...(withToastError && { onError: toast.error }),
    ...options,
  });